"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onKeyDown = exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _react = require("react");
var _cnbuilder = require("cnbuilder");
var _arrowDownDefault = _interopRequireDefault(require("@teladoc/pulse/icons/arrow-down-default.svg"));
var _Panel = _interopRequireDefault(require("../Panel"));
var _AccordionModule = _interopRequireDefault(require("./Accordion.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const onKeyDown = triggers => evt => {
  const {
    target,
    key
  } = evt;
  const {
    current: trigs
  } = triggers;
  let newIndex = 0;
  switch (key) {
    case 'ArrowUp':
    case 'ArrowDown':
      {
        evt.preventDefault();
        const curIndex = trigs.indexOf(target);
        const dir = key === 'ArrowUp' ? -1 : 1;
        const len = trigs.length;
        newIndex = (curIndex + len + dir) % len;
        trigs[newIndex].focus();
        return newIndex;
      }
    case 'End':
      evt.preventDefault();
      newIndex = trigs.length - 1;
      trigs[newIndex].focus();
      return newIndex;
    case 'Home':
      evt.preventDefault();
      trigs[newIndex].focus();
      return newIndex;
  }
};
exports.onKeyDown = onKeyDown;
const Accordion = _ref => {
  let {
    className,
    testAttr,
    items,
    closeOthersOnClick
  } = _ref;
  const accordionRef = (0, _react.useRef)(null);
  const triggers = (0, _react.useRef)([]);
  const [allItems, setAllItems] = (0, _react.useState)(() => items.map((item, i) => _objectSpread(_objectSpread({}, item), {}, {
    id: i
  })));
  const onToggleItem = _ref2 => {
    let {
      id
    } = _ref2;
    setAllItems(currentItems => currentItems.map((item, i) => _objectSpread(_objectSpread({}, item), {}, {
      isOpen: i === id
    })));
  };
  (0, _react.useEffect)(() => {
    accordionRef.current.querySelectorAll('button[data-panel-trigger="true"]').forEach(trigger => triggers.current.push(trigger));
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    ref: accordionRef,
    className: (0, _cnbuilder.cnb)(_AccordionModule.default.root, className),
    "data-test": testAttr,
    children: allItems.map((item, i) => {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Panel.default, _objectSpread(_objectSpread({}, item), {}, {
        classNameTrigger: (0, _cnbuilder.cnb)(_AccordionModule.default.triggerContainer, item.classNameTrigger),
        classNameTriggerExpanded: _AccordionModule.default.triggerArrowInverse,
        classNameContent: (0, _cnbuilder.cnb)(_AccordionModule.default.content, item.classNameContent),
        trigger: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: item.panelIcon && _AccordionModule.default['trigger-icon'],
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              className: (0, _cnbuilder.cnb)(item.description ? _AccordionModule.default['with-description'] : _AccordionModule.default['no-description'], item.panelIcon && _AccordionModule.default['with-icon']),
              "data-test": item.panelIcon ? 'panel-icon' : '',
              children: [item.panelIcon, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                className: _AccordionModule.default.trigger,
                children: item.trigger
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                className: (0, _cnbuilder.cnb)(_AccordionModule.default.description, item.panelIcon ? '' : _AccordionModule.default['no-icon']),
                "data-test": item.description ? 'panel-description' : '',
                children: item.description
              })]
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: _AccordionModule.default.triggerArrow,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_arrowDownDefault.default, {
              className: _AccordionModule.default.arrow
            })
          })]
        }),
        onKeyDown: onKeyDown(triggers)
      }, closeOthersOnClick && {
        onToggle: onToggleItem
      }), i);
    })
  });
};
Accordion.defaultProps = {
  testAttr: 'accordion'
};
var _default = exports.default = Accordion;